export default __webpack_public_path__ + "static/media/AvenirNextLTPro-Bold.09bc26d0.woff2";